import { ReactComponent as MessageCircle } from "./../../assets/img/chatMessageCircle.svg";
import { ReactComponent as X } from "./../../assets/img/chatCloseIcon.svg";
import { ReactComponent as Headphones } from "./../../assets/img/ChatHeadphones.svg";
import { ReactComponent as BookOpen } from "./../../assets/img/ChatBookOpen.svg";
import { useContext, useState } from "react";
import { AuthContext } from "context/AuthContext";
import { roleName } from "constants_map";

     function ChatWidget() {
        const { globalConfig, userRole } = useContext(AuthContext);
        const contactWhatsapp = globalConfig.find((e) => e.key === "contactWhatsapp")?.value || "";
        const [isChatOpen, setIsChatOpen] = useState(false);

        const path =
            userRole === roleName.enterpriseAdmin
              ? "/Account/index.htm#t=FAQs_%26_Tutorials.htm"
              : userRole === roleName.enterpriseUser
              ? "/User/index.htm#t=Web-based_Operations%2FFAQs_%26_Tutorials.htm"
              : userRole === roleName.platformAdmin
              ? "/Admin/index.htm#t=FAQs_%26_Tutorials.htm"
              : "/Admin/index.htm#t=FAQs_%26_Tutorials.htm";

        return <>
     {/* Chat Widget */}
      <button 
        onClick={() => setIsChatOpen(!isChatOpen)}
        style={{
          zIndex: 100
        }}
        className="fixed right-6 bottom-6 w-14 h-14 bg-red-500 text-white rounded-full shadow-lg hover:bg-red-600 transition-all flex items-center justify-center group hover:scale-110"
      >
        {isChatOpen ? <X className="w-6 h-6" /> : <MessageCircle className="w-6 h-6" />}
      </button>

      {/* Chat Popup */}
      {isChatOpen && (
        <div style={{
          zIndex: 100
        }} className="fixed right-6 bottom-24 w-80 bg-white rounded-2xl shadow-2xl overflow-hidden border border-gray-200">
          {/* Header */}
          <div className="bg-red-500 px-6 py-5 text-white">
            <h3 className="flex items-center gap-2 text-lg font-medium">
              Hi User 
              <span className="text-xl">👋</span>
            </h3>
            <p className="text-sm text-red-50 mt-1">How can we help you?</p>
          </div>

          {/* Options */}
          <div className="p-4 space-y-3">
            {/* Chat with Support */}
            {/* <button className="w-full flex items-start gap-4 p-4 rounded-xl hover:bg-gray-50 transition-colors text-left border border-gray-100">
              <div className="w-10 h-10 rounded-full bg-pink-100 flex items-center justify-center flex-shrink-0">
                <Headphones className="w-5 h-5 text-pink-600" />
              </div>
              <div className="flex-1">
                <h4 className="text-sm font-medium text-gray-900">Smart Chat Assistant</h4>
                <p className="text-xs text-gray-500 mt-0.5">Get instant answers with AI assistance</p>
              </div>
            </button> */}

            {/* WhatsApp Support */}
           {contactWhatsapp && <a 
              href={`https://wa.me/${contactWhatsapp}`}
              target="_blank"
              className="w-full flex items-start gap-4 p-4 rounded-xl hover:bg-gray-50 transition-colors text-left border border-gray-100"
            >
              <div className="w-10 h-10 rounded-full bg-green-100 flex items-center justify-center flex-shrink-0">
                <svg className="w-5 h-5 text-green-600" fill="currentColor" viewBox="0 0 24 24">
                  <path d="M17.472 14.382c-.297-.149-1.758-.867-2.03-.967-.273-.099-.471-.148-.67.15-.197.297-.767.966-.94 1.164-.173.199-.347.223-.644.075-.297-.15-1.255-.463-2.39-1.475-.883-.788-1.48-1.761-1.653-2.059-.173-.297-.018-.458.13-.606.134-.133.298-.347.446-.52.149-.174.198-.298.298-.497.099-.198.05-.371-.025-.52-.075-.149-.669-1.612-.916-2.207-.242-.579-.487-.5-.669-.51-.173-.008-.371-.01-.57-.01-.198 0-.52.074-.792.372-.272.297-1.04 1.016-1.04 2.479 0 1.462 1.065 2.875 1.213 3.074.149.198 2.096 3.2 5.077 4.487.709.306 1.262.489 1.694.625.712.227 1.36.195 1.871.118.571-.085 1.758-.719 2.006-1.413.248-.694.248-1.289.173-1.413-.074-.124-.272-.198-.57-.347m-5.421 7.403h-.004a9.87 9.87 0 01-5.031-1.378l-.361-.214-3.741.982.998-3.648-.235-.374a9.86 9.86 0 01-1.51-5.26c.001-5.45 4.436-9.884 9.888-9.884 2.64 0 5.122 1.03 6.988 2.898a9.825 9.825 0 012.893 6.994c-.003 5.45-4.437 9.884-9.885 9.884m8.413-18.297A11.815 11.815 0 0012.05 0C5.495 0 .16 5.335.157 11.892c0 2.096.547 4.142 1.588 5.945L.057 24l6.305-1.654a11.882 11.882 0 005.683 1.448h.005c6.554 0 11.89-5.335 11.893-11.893a11.821 11.821 0 00-3.48-8.413Z"/>
                </svg>
              </div>
              <div className="flex-1">
                <h4 className="text-sm font-medium text-gray-900">WhatsApp Support</h4>
                <p className="text-xs text-gray-500 mt-0.5">Continue on WhatsApp</p>
              </div>
            </a>}

            {/* Help Center */}
            <a 
              href={path}
              target="_blank"
              className="w-full flex items-start gap-4 p-4 rounded-xl hover:bg-gray-50 transition-colors text-left border border-gray-100 text-decoration-none"
            >
              <div className="w-10 h-10 rounded-full bg-purple-100 flex items-center justify-center flex-shrink-0">
                <BookOpen className="w-5 h-5 text-purple-600" />
              </div>
              <div className="flex-1">
                <h4 className="text-sm font-medium text-gray-900">Help Center</h4>
                <p className="text-xs text-gray-500 mt-0.5">Browse Help Articles, FAQs and Video Tutorials</p>
              </div>
            </a>
          </div>

          {/* Close Button */}
          <button 
            onClick={() => setIsChatOpen(false)}
            className="absolute -bottom-14 right-0 w-12 h-12 bg-red-500 text-white rounded-full flex items-center justify-center hover:bg-red-600 transition-colors shadow-lg"
          >
            <X className="w-5 h-5" />
          </button>
        </div>
      )}
      </>
    }

    export default ChatWidget;